// extracted by mini-css-extract-plugin
export default {"modal":"modal-a8Bo"};